module.exports = __webpack_public_path__ + "img/poly-12.fd7c02a2.png";